import { render, staticRenderFns } from "./department-item.vue?vue&type=template&id=88fef0ca"
import script from "./department-item.vue?vue&type=script&lang=js"
export * from "./department-item.vue?vue&type=script&lang=js"
import style0 from "./department-item.vue?vue&type=style&index=0&id=88fef0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports